import { render } from "./detailsOffCanvas.vue?vue&type=template&id=3f708248&scoped=true"
import script from "./detailsOffCanvas.vue?vue&type=script&lang=js"
export * from "./detailsOffCanvas.vue?vue&type=script&lang=js"

import "./detailsOffCanvas.vue?vue&type=style&index=0&id=3f708248&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f708248"]])

export default __exports__